export enum RaffleDefaultTicketPurchaseStatusEnum {
  PAID = "p",
  REFUND = "r",
}

export type RaffleDefaultTicketPurchaseStatusTypes =
  `${RaffleDefaultTicketPurchaseStatusEnum}`;
